<template>
  <v-dialog
      :value="dialog"
      @input="alertAction"
      max-width="500"
      style="z-index: 9999"
      :persistent="option.persistent ? option.persistent : false"
  >
    <v-card>
      <v-card-text class="pa-5 text-center">
<!--        <slot>{{ text }}</slot>-->
        <div v-html="text"></div>

      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="primary"
            text
            @click="alertAction"
        >
          확인
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "TextAlert",
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    text: {
      type: String,
    },
    option: {
      type:Object,
      default:Object
    }

  },
  methods: {
    alertAction: function () {
      this.$emit('alertAction');
    },
  }
}
</script>

<style scoped>

</style>